import { Injectable } from '@angular/core';
import { UrlTree, CanActivate, Router } from '@angular/router';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { filter, Observable, of, switchMap } from 'rxjs';

import { isNonNull } from './redeem-blocked.guard';

@Injectable({
  providedIn: 'root',
})
export class UserIndiaGuard implements CanActivate {
  constructor(private router: Router, private authStore: AuthStoreService) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authStore.isRegularUser$.pipe(
      filter(isNonNull),
      switchMap((isRegularUser: boolean) => {
        if (isRegularUser) {
          if (this.isIndiaUser()) {
            this.router.navigateByUrl('/gold-or-platinum-tier-allowed');
            return of(false);
          }
        }
        return of(true);
      })
    );
  }

  private isIndiaUser() {
    return this.authStore.userSettings?.country?.alpha2Code === 'IN';
  }
}
